import React from 'react';

// Editorial page hero (short banner with image)
export const PageHero = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative h-[55vh] min-h-[400px] flex items-center justify-center overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0">
      <img src={image} alt={title} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,16,32,0.75)_0%,rgba(10,16,32,0.45)_50%,rgba(10,16,32,0.80)_100%)]" />
    </div>
    <div className="relative z-10 text-center text-white px-6 max-w-4xl pt-20">
      {eyebrow && <p className="text-gold text-xs tracking-[0.35em] uppercase mb-4">{eyebrow}</p>}
      <h1 className="font-serif text-4xl md:text-6xl font-bold mb-4 leading-tight drop-shadow-2xl">
        {title}
      </h1>
      <div className="flex items-center justify-center gap-3 my-6">
        <div className="h-px w-16 bg-gradient-to-r from-transparent to-gold" />
        <div className="w-1.5 h-1.5 rotate-45 bg-gold" />
        <div className="h-px w-16 bg-gradient-to-l from-transparent to-gold" />
      </div>
      {subtitle && (
        <p className="font-serif italic text-lg md:text-2xl text-gold/95 max-w-2xl mx-auto">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

// Elegant centered section heading (for ivory sections)
export const SectionHeading = ({ eyebrow, title, accent, subtitle }) => (
  <div className="text-center mb-14 max-w-3xl mx-auto">
    {eyebrow && <p className="text-gold text-sm tracking-[0.3em] uppercase mb-3">{eyebrow}</p>}
    <h2 className="font-serif text-3xl md:text-5xl font-bold text-navy mb-4">
      {title}{accent && <span className="text-gold italic"> {accent}</span>}
    </h2>
    <div className="flex items-center justify-center gap-3 mx-auto mb-5">
      <div className="h-px w-16 bg-gradient-to-r from-transparent to-gold" />
      <div className="w-1.5 h-1.5 rotate-45 bg-gold" />
      <div className="h-px w-16 bg-gradient-to-l from-transparent to-gold" />
    </div>
    {subtitle && (
      <p className="text-slate-600 text-lg italic leading-relaxed">{subtitle}</p>
    )}
  </div>
);
